import { CanvasEntityMapping } from '@panaya/ai-chat/canvas-draft';
import { SeemoreTest } from './seemore-test.model';

/**
 * How the Seemore canvas draws a `TM_TEST` draft entity: the Test Builder agent's test data, which is the create
 * endpoint's `TestAiResponseBean` (`as-bl` `generateWithAi`, with its `StepAiResponseBean` steps), typed as
 * `SeemoreTest`. Every path below is checked against that type when the host compiles, so a misspelt or renamed field is
 * a build error. Label keys live in the as-web-site English locale under `seemore.canvas.test`.
 *
 * This is the example for any agent that brings its own entity type: the data's interface, one mapping like this typed by
 * it, and a `provideCanvasEntityMapping` call in the agent's provider bundle (`seemore-canvas.providers.ts`).
 */
export const TEST_CANVAS_ENTITY_MAPPING: CanvasEntityMapping<SeemoreTest> = {
    id: 'id',
    title: 'title',
    countLabelKey: 'seemore.canvas.test.count',
    tabs: [
        {
            labelKey: 'seemore.canvas.test.steps',
            path: 'steps',
            rowId: 'order',
            columns: [
                { path: 'description', labelKey: 'seemore.canvas.test.step_description' },
                { path: 'expectedResult', labelKey: 'seemore.canvas.test.expected_result' },
                { path: 'transaction', type: 'transaction', labelKey: 'seemore.canvas.test.transaction' }
            ]
        }
    ]
};
